import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

import { useAuthStore } from '@/shared/auth/stores/authStore'

// Parent layout for /hod/* routes. Auth-gates the whole subtree AND
// role-gates: only HODs land here. Admins/super_admins trying to visit
// get bounced to /entities; FOs get bounced to /mobile-only.
export const Route = createFileRoute('/hod')({
  beforeLoad: () => {
    const state = useAuthStore.getState()
    if (!state.isAuthenticated) {
      throw redirect({ to: '/login' })
    }
    const role = state.user?.role_name
    if (role === 'super_admin' || role === 'admin') {
      throw redirect({ to: '/entities' })
    }
    if (role === 'field_officer') {
      throw redirect({ to: '/mobile-only' })
    }
    if (role !== 'hod') {
      throw redirect({ to: '/login' })
    }
  },
  component: () => <Outlet />,
})
